import React from "react";

const TCInvoicingTab = ({ settings, setSettings, showDailyOption = false }) => {
  return (
    <div className="invoice-settings">
      <div className="row">
        <div className="col-md-6">
          <div className="cp-split">
            <label className="fi-label">Invoicing Frequency <span style={{ color: "red" }}>*</span></label>
            <select className="common-select" value={settings?.invoice_frequency || ""} onChange={(e) => setSettings((prev) => ({ ...prev, invoice_frequency: e.target.value, }))}>
              {showDailyOption && <option value="Every Day">Every Day</option>}
              <option value="7 Days">7 Days</option>
              <option value="14 Days">14 Days</option>
              <option value="30 Days">30 Days</option>
            </select>
          </div>
        </div>

        <div className="col-md-6">
          <div className="cp-split">
            <label className="fi-label">Invoice Will Due In <span style={{ color: "red" }}>*</span></label>
            <select className="common-select" value={settings?.invoice_due || ""} onChange={(e) => setSettings((prev) => ({ ...prev, invoice_due: e.target.value, }))} >
              <option value="Net 7">Net 7</option>
              <option value="Net 15">Net 15</option>
              <option value="Net 30">Net 30</option>
              <option value="Net 45">Net 45</option>
              <option value="Net 60">Net 60</option>
            </select>
          </div>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-md-12">
          <div className="cp-split">
            <label className="fi-label">Commission Rate (%) <span style={{ color: "red" }}>*</span></label>
            <input className="common-input" type="number" value={settings?.invoice_commission || ""} onChange={(e) => setSettings((prev) => ({ ...prev, invoice_commission: e.target.value, }))} placeholder="Enter rate" />
          </div>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-md-12">
          <div className="cp-split">
            <label className="fi-label">Tax Percent (%) <span style={{ color: "red" }}>*</span></label>
            <input className="common-input" type="number" value={settings?.invoice_tax_percent || ""} onChange={(e) => setSettings((prev) => ({ ...prev, invoice_tax_percent: e.target.value, }))} placeholder="Enter tax percent" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TCInvoicingTab;